interface ILinks {
  HEADER: {
    HELP_AND_SUPPORT: string;
    SEARCH: string;
    LOGIN: string;
  };
}

export const LINKS: ILinks = {
  HEADER: {
    HELP_AND_SUPPORT: "/help-and-support.html",
    SEARCH: "/search-results.html",
    LOGIN: "/my-account.html#login"
  }
};
